import { Component, ViewChild, ErrorHandler } from '@angular/core';
import { Platform, Events, NavController, App, Tabs, MenuController, AlertController } from 'ionic-angular';
import { SplashScreen } from '@ionic-native/splash-screen';
import { SettingsProvider } from '../providers/settings/settings';
import { LanguageProvider } from '../providers/language/language';
import { Title, DomSanitizer } from '@angular/platform-browser';
import { GlobalvariablesProvider } from './../providers/globalvariables/globalvariables';
import { Device } from '@ionic-native/device';
import { FCM } from '@ionic-native/fcm';
import { SavingsAccountsProvider } from './../providers/savings-accounts/savings-accounts';
import { Network } from '@ionic-native/network';
import { OnboardingProvider } from '../providers/onboarding/onboarding';
import { GatewayClientProvider } from '../providers/gateway-client/gateway-client';
import { InactiveProvider } from '../providers/inactive/inactive';
import { LocalNotifications } from '@ionic-native/local-notifications';
import { ProductsProvider } from "../providers/products/products";
import { Badge } from '@ionic-native/badge';
import { InAppBrowser } from '@ionic-native/in-app-browser';
// import { AppRate, AppRatePreferences } from '@ionic-native/app-rate';



declare var IRoot;
declare var window;
declare var document;

class ConsectusErrorHandler implements ErrorHandler {
  handleError(err: any): void {
    // 
  }
}


@Component({
  templateUrl: 'app.html'
})
export class ConsectusApp {
  isMobile: boolean = false;
  isWebOnboarding: boolean = true;
  rootPage: any = "WebLoginPage";
  isRooted: boolean = false;
  resumed: boolean = false;
  messageBadgeCount = 0;
  productBadgeCount = 0;
  newscount = 0;
  timeoutID: any;
  customerStatus: any;
  // public modal: any;
  public blockModal: any;
  public resultToken: any;
  myVar: any;
  @ViewChild('mainNav') nav: NavController;
  @ViewChild('consectusTabs') tabs: Tabs;
  public deviceToken: any;
  public pageIndex: any;
  public lastView: any = null;
  memberFlag: any;
  clientDemo: any = window.clientDemo;
  bankSettingOtherData: any;
  splitPaneState: any;
  updateDeviceTokenData: any;
  loading: any;
  eventListner: any = false;
  deviceIdToken: any = "";
  settings: any;
  bankSettingData: any = [];
  count: any;
  banksettings = [];
  customername = "";
  appVersion: any = window.AppVersion;
  totalcount = 0;//this.settingsProvider.settings.totalcount;
  sql_db = null;


  statusBarMarginTop = {
    'iPhone 4': 'status-20',
    'iPhone 4S': 'status-20',
    'iPhone 5': 'status-20',
    'iPhone 5c': 'status-20',
    'iPhone 5s': 'status-20',
    'iPhone 6': 'status-20',
    'iPhone 6s': 'status-20',
    'iPhone 6 Plus': 'status-20',
    'iPhone 6s Plus': 'status-20',
    'iPhone SE': 'status-20',
    'iPhone 7': 'status-20',
    'iPhone 7 Plus': 'status-20',
    'iPhone 8': 'status-20',
    'iPhone 8 Plus': 'status-20',
    'iPad': 'status-20',
    'iPhone X': 'status-30',
    'iPhone XR': 'status-30',
    'iPhone XS': 'status-30',
    'iPhone XS Max': 'status-30',
    'iPhone 11': 'status-30',
    'iPhone 11 Pro': 'status-30',
    'iPhone 11 Pro Max': 'status-30',
    'iPhone 12': 'status-30',
    'iPhone 12 Pro': 'status-30',
    'iPhone 12 Pro Max': 'status-30',
    'iPhone 12 Mini': 'status-30',
    "iPhone SE 2nd Gen": "status-20",
    'iPhone 13': 'status-30',
    'iPhone 13 Pro': 'status-30',
    'iPhone 13 Pro Max': 'status-30',
    'iPhone 13 Mini': 'status-30'
  }
  iosModels = {
    'iPhone3,1': 'iPhone 4',
    'iPhone3,2': 'iPhone 4',
    'iPhone3,3': 'iPhone 4',
    'iPhone4,1': 'iPhone 4S',
    'iPhone5,1': 'iPhone 5',
    'iPhone5,2': 'iPhone 5',
    'iPhone5,3': 'iPhone 5c',
    'iPhone5,4': 'iPhone 5c',
    'iPhone6,1': 'iPhone 5s',
    'iPhone6,2': 'iPhone 5s',
    'iPhone7,2': 'iPhone 6',
    'iPhone7,1': 'iPhone 6 Plus',
    'iPhone8,1': 'iPhone 6s',
    'iPhone8,2': 'iPhone 6s Plus',
    'iPhone8,4': 'iPhone SE',
    'iPhone9,1': 'iPhone 7',
    'iPhone9,3': 'iPhone 7',
    'iPhone9,2': 'iPhone 7 Plus',
    'iPhone9,4': 'iPhone 7 Plus',
    'iPhone10,1': 'iPhone 8',
    'iPhone10,4': 'iPhone 8',
    'iPhone10,2': 'iPhone 8 Plus',
    'iPhone10,5': 'iPhone 8 Plus',
    'iPhone10,3': 'iPhone X',
    'iPhone10,6': 'iPhone X',
    'iPhone11,8': 'iPhone XR',
    'iPhone11,2': 'iPhone XS',
    'iPhone11,4': 'iPhone XS Max',
    'iPhone11,6': 'iPhone XS Max',
    'x86_64': 'iPhone XS Max',
    'iPhone12,1': 'iPhone 11',
    'iPhone12,3': 'iPhone 11 Pro',
    'iPhone12,5': 'iPhone 11 Pro Max',
    'iPhone13,1': 'iPhone 12 Mini',
    'iPhone13,2': 'iPhone 12',
    'iPhone13,3': 'iPhone 12 Pro',
    'iPhone13,4': 'iPhone 12 Pro Max',
    "iPhone12,8": "iPhone SE 2nd Gen",
    "iPhone14,2": "iPhone 13 Pro",
    "iPhone14,3": "iPhone 13 Pro Max",
    "iPhone14,4": "iPhone 13 Mini",
    "iPhone14,5": "iPhone 13",

    'iPad1,1': 'iPad',
    'iPad1,2': 'iPad',
    'iPad2,1': 'iPad',
    'iPad2,2': 'iPad',
    'iPad2,3': 'iPad',
    'iPad2,4': 'iPad',
    'iPad3,1': 'iPad',
    'iPad3,2': 'iPad',
    'iPad3,3': 'iPad',
    'iPad2,5': 'iPad',
    'iPad2,6': 'iPad',
    'iPad2,7': 'iPad',
    'iPad3,4': 'iPad',
    'iPad3,5': 'iPad',
    'iPad3,6': 'iPad',
    'iPad4,1': 'iPad',
    'iPad4,2': 'iPad',
    'iPad4,3': 'iPad',
    'iPad4,4': 'iPad',
    'iPad4,5': 'iPad',
    'iPad4,6': 'iPad',
    'iPad4,7': 'iPad',
    'iPad4,8': 'iPad',
    'iPad4,9': 'iPad',
    'iPad5,1': 'iPad',
    'iPad5,2': 'iPad',
    'iPad5,3': 'iPad',
    'iPad5,4': 'iPad',
    'iPad6,3': 'iPad Pro',
    'iPad6,4': 'iPad Pro',
    'iPad6,7': 'iPad Pro',
    'iPad6,8': 'iPad Pro',
    'iPad6,11': 'iPad Pro',
    'iPad6,12': 'iPad Pro',
    'iPad7,1': 'iPad Pro',
    'iPad7,2': 'iPad Pro',
    'iPad7,3': 'iPad Pro',
    'iPad7,4': 'iPad Pro',
    'iPad7,5': 'iPad Pro',
    'iPad7,6': 'iPad Pro',
    'iPad8,1': 'iPad Pro',
    'iPad8,2': 'iPad Pro',
    'iPad8,3': 'iPad Pro',
    'iPad8,4': 'iPad Pro',
    'iPad8,5': 'iPad Pro',
    'iPad8,6': 'iPad Pro',
    'iPad8,7': 'iPad Pro',
    'iPad8,8': 'iPad Pro',
    "iPad8,9": "iPad Pro 11 inch 2nd Gen (WiFi)",
    "iPad8, 10": "iPad Pro 11 inch 2nd Gen (WiFi+Cellular)",
    "iPad8, 11": "iPad Pro 12.9 inch 4th Gen (WiFi)",
    "iPad8, 12": "iPad Pro 12.9 inch 4th Gen (WiFi+Cellular)",
    "iPad11, 1": "iPad mini 5th Gen (WiFi)",
    "iPad11, 2": "iPad mini 5th Gen",
    "iPad11, 3": "iPad Air 3rd Gen (WiFi)",
    "iPad11, 4": "iPad Air 3rd Gen"
  }

  constructor(
    private badge: Badge,
    private platform: Platform,
    private events: Events,
    private splashScreen: SplashScreen,
    private app: App,
    public settingsProvider: SettingsProvider,
    public alertCtrl: AlertController,
    // private modalCtrl: ModalController,
    public gateway: GatewayClientProvider,
    private languageProvider: LanguageProvider,
    public savingsAccountsProvider: SavingsAccountsProvider,
    public title: Title, public menu: MenuController,
    public productsProvider: ProductsProvider,
    public global: GlobalvariablesProvider,
    private device: Device,
    private fcm: FCM,
    public onboardingProvider: OnboardingProvider,
    private network: Network,
    public localNotifications: LocalNotifications,
    public inactive: InactiveProvider,
    public browser: InAppBrowser,
    public _DomSanitizer: DomSanitizer
  ) {

    window.app = this;
    this.customername = window.customerName;
    this.splitPaneState = false;
    if (platform.is('android') || platform.is('ios')) {

      // if(platform.is('android')){
      //   window.hidePadding
      // }

      document.addEventListener("offline", window.slowNetError, false);

    }
    this.events.subscribe("consectus:network.error", window.show500);
    this.events.subscribe("consectus:network.slow", window.slowNetError);
    this.events.subscribe("consectus:oauth.fail", window.slowNetError);
    this.events.subscribe("consectus:500.error", window.show500);
    this.events.subscribe("consectus:badgehome.update", (data) => { this.updateBadge(data); });
    this.events.subscribe('HOMEBUTTON', (data) => {
      this.nav.setRoot("HomePage")
    });
    this.events.subscribe('EVENT_PRODUCTPAGE', (data) => {
      this.nav.setRoot("HomePage");
      this.events.publish("EVENT_PRODUCT_WEBACCOUNTSPAGE", data)
    });
    this.events.subscribe('consectus:401.error', (data) => {
      window.show401(JSON.parse(data._body))
    });
    this.events.subscribe("consectus:404.error", window.show404);
    // this.events.subscribe("consectus:settings.ready", this.hideSplashScreen.bind(this));
    //show error message when the network status changes and remove it when it is restored.
    // deal with any internal network error event and force user to reload the page

    let self = this;

    platform.ready().then(() => {
      try {
        window.addEventListener('native.keyboardshow', function () {
          window.Keyboard.disableScroll(false);
        });
        if (platform.is('android') || platform.is('ios')) {
          self.sql_db = window.sqlitePlugin.openDatabase({ name: 'consectus.db', location: 'default' });
          self.sql_db.transaction(function (transaction) {
            transaction.executeSql('CREATE TABLE IF NOT EXISTS tblconsectus (id integer primary key, title text)', [],
              function (tx1, result) {
                self.sql_db.transaction(function (select_transaction) {
                  select_transaction.executeSql("SELECT COUNT(*) AS rowcount FROM tblconsectus", [], function (tx, select_result) {
                  },
                    function (select_error) {
                    })
                })
                self.sql_db.transaction(function (insert_transaction) {
                  insert_transaction.executeSql("INSERT INTO tblconsectus (title) VALUES (?)", ["hello"], function (tx2, result2) {
                    self.sql_db.transaction(function (select_transaction) {
                      select_transaction.executeSql("SELECT COUNT(*) AS rowcount FROM tblconsectus WHERE title=?;", ["hello"], function (tx3, result3) {
                      },
                        function (insert_error) {
                        });
                    });
                  },
                    function (insert_error) {
                    });
                });
              },
              function (create_error) {
              });
          });
        }
        if (IRoot !== undefined) {

          IRoot.isRooted((booleanVal) => {
            self.isRooted = booleanVal;

          }, (err) => {

          });
        }
      }
      catch (e) {

      }
      //self.isRooted = true;
      //hode ConnectionNotSecure when platform is ready
      window.hideConnectionNotSecure();
      if (self.isRooted) {
        if (device.platform == "Android") {
          // window.showRootedError();
        }
        else {
          // window.showJailBreakError();
        }
      } else {


        //deal with no network when the app was launched
        if (self.network.type === "none") {
          window.slowNetError();
        }


        if (window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches) {
          // dark mode

          window.addDarkMode();
        }
        else {

          window.addLightMode();
        }


        if (platform.is('ios')) {
          const className = self.statusBarMarginTop[self.iosModels[self.device.model]];
          if (className != undefined) window.adjustStatusBar(className);
        }
        //if the app is running on browser or mobile browser or development mode browser
        if (true) {

          self.isMobile = false;
          self.initializeOnline(false); //is development mode = false
        } else if (window.document.URL.indexOf("8100") < 0 && !self.platform.is('cordova')) {

          // self.settingsProvider.isDev = false;
          self.initializeOnline(true); // is development mode == true
        } else {
          // self.settingsProvider.isDev = false;




          self.initializeApp();
          self.splashScreen.hide();
        }
      }
    });
    self.settingsProvider.getAccountBanksetting().then((result: any) => {
      let s = self.settingsProvider.settings;
      s.bank_sortcode = result.bank_sortcode;
      s.bank_accountno = result.bank_accountno;
      s.feature_nonpersonalregistration = result.feature_nonpersonalregistration;
      s.feature_personal = result.feature_personal;
      s.feature_client_peronsal = result.feature_client_peronsal;
      s.feature_business_charity_trust = result.feature_business_charity_trust;
      s.transfer_max_day = result.transfer_max_day;
      self.settingsProvider.setSettings(s).then(() => {

      }).catch(() => {

      });

    }).catch((banksetting_err) => {
    })

    this.settingsProvider.getOnlineLabels()
    this.gateway.getAccessToken().then(() => {
      window.hideSplash();
    }).catch((access_error) => {
      console.log(access_error);
    });
  }



  //Hide the splitpane according to device width
  getSplitPane() {
    if (this.platform.is("core") || this.platform.is("mobileweb")) {
      if (this.platform.width() >= 768) {
        this.splitPaneState = true;
        return true;
      }
      else {
        this.splitPaneState = false;
        return false;
      }
    } else {
      let statusNav = this.nav.getActive();
      if (statusNav == undefined) {
        this.splitPaneState = false;
      } else {
        if (statusNav.component.name == "WebLoginPage") {
          this.splitPaneState = false;
        } else {
          // 
          if (this.platform.width() >= 768 && (this.platform.is('core') || this.platform.is('mobileweb'))) {
            this.splitPaneState = true;
          } else if (this.platform.width() <= 768 && (this.platform.is('core') || this.platform.is('mobileweb'))) {
            this.splitPaneState = false;
          }
        }
      }
      return this.splitPaneState;

    }
  }

  hideSplashScreen() {
    this.splashScreen.hide();
  }

  updateBadge(data) {
    this.badge.decrease(1);
    if (data == "product") {
      this.productBadgeCount = this.productBadgeCount - 1;
    }
    else if (data == "message") {
      this.messageBadgeCount = this.messageBadgeCount - 1;
    }
    this.events.publish("consectus:badge.change", data)
  }

  initializeApp() {
    let self = this;
    /**
     * after session out it should redierect to login page
     */
    this.events.subscribe("consectus:loginform", () => {

      // self.nav.setRoot("LoginFormPage")
      this.settingsProvider.showLoading();
      // this.menu_option = false;
      location.href = "#/web-login";
      setTimeout(() => {
        this.settingsProvider.hideLoading();
        location.reload();
      }, 1500);
    });

    /**
     * tokenn refresh once get null from getToken
     */
    window.FCMPlugin.onTokenRefresh(function (token) {

      self.getToken();
    });


    window.FCMPlugin.onNotification(function (data) {

      let s = self.settingsProvider.settings;

      if (data.type == 'NewAccount') {
        s.account_number = data.account_number;
        self.settingsProvider.setSettings(s).then().catch();
        self.app.getRootNavs()[0].setRoot("ScreenMessagePage")
      }

      if (Number.isNaN(s.notification_id)) {
        s.notification_id = 1;
      }
      else {
        s.notification_id += 1;
      }
      if (data.wasTapped) {
        if (data.type != undefined) {
          if (data.type == 'NewAccount') {
            s.account_number = data.account_number;
            self.settingsProvider.setSettings(s).then().catch();
            self.app.getRootNavs()[0].setRoot("ScreenMessagePage")
          }
        }
        if (data.page == "ProductsPage") {
          s.notification = data;
          s.productnotifications.push(data);
        } else if (data.page == "MessagesPage") {
          s.notification = data;
          s.messagenotifications.push(data);
        } else if (data.page == "LoginBlockedPage") {
          s.notification = data;
        } else if (data.title == "Account Unlocked") {
          s.isSendLoginMail = false;
          s.isLoginBlocked = false;
          s.isApplicationBlocked = false;
          s.status = "Active";
          s.attempts = 0;
          self.settingsProvider.setSettings(s);
          self.events.publish("consectus:loginform");
        } else if (data.page == "MobileVerificationPage") {
          s.status = data.state_status;
          self.settingsProvider.setSettings(s);
          self.settingsProvider.getAllStatus();
        }

      } else {
        self.localNotifications.schedule({
          id: s.notification_id,
          title: data.title,
          text: data.body,
          icon: 'fcm_push_icon',
          color: '#41b656',
          data: data
        });

      }
      self.events.publish("consectus:products.visited")
    });


    /**
     * This code used for push notifications
     */
    // this.fcm.onNotification().subscribe(data => {
    //   let s = self.settingsProvider.settings;
    //   
    //   if (data.type == 'NewAccount') {
    //     s.account_number = data.account_number;
    //     this.settingsProvider.setSettings(s).then().catch();
    //     self.app.getRootNavs()[0].setRoot("ScreenMessagePage")
    //   }

    //   if (Number.isNaN(s.notification_id)) {
    //     s.notification_id = 1;
    //   }
    //   else {
    //     s.notification_id += 1;
    //   }
    //   if (data.wasTapped) {
    //     if (data.type != undefined) {
    //       if (data.type == 'NewAccount') {
    //         s.account_number = data.account_number;
    //         this.settingsProvider.setSettings(s).then().catch();
    //         self.app.getRootNavs()[0].setRoot("ScreenMessagePage")
    //       }
    //     }
    //     if (data.page == "ProductsPage") {
    //       s.notification = data;
    //       s.productnotifications.push(data);
    //     } else if (data.page == "MessagesPage") {
    //       s.notification = data;
    //       s.messagenotifications.push(data);
    //     } else if (data.page == "LoginBlockedPage") {
    //       s.notification = data;
    //     } else if (data.title == "Account Unlocked") {
    //       s.isSendLoginMail = false;
    //       s.isLoginBlocked = false;
    //       s.isApplicationBlocked = false;
    //       s.status = "Active";
    //       s.attempts = 0;
    //       self.settingsProvider.setSettings(s);
    //       this.events.publish("consectus:loginform");
    //     } else if (data.page == "MobileVerificationPage") {
    //       s.status = data.state_status;
    //       self.settingsProvider.setSettings(s);
    //       self.settingsProvider.getAllStatus();
    //     }
    //     
    //   } else {
    //     this.localNotifications.schedule({
    //       id: s.notification_id,
    //       title: data.title,
    //       text: data.body,
    //       icon: 'fcm_push_icon',
    //       color: '#41b656',
    //       data: data
    //     });
    //     
    //   }
    //   self.events.publish("consectus:products.visited")
    // });

    this.platform.pause.subscribe(e => {
      self.inactive.stopCount();
      if (self.app.getActiveNavs()[0].getActive().id == undefined) {
        self.lastView = "AccountsPage";
      }
      else {
        self.lastView = self.app.getActiveNavs()[0].getActive().id;
      }
      this.inactive.stopCount();
      self.menu.enable(true);
      for (let i = 0; i < 100; i++) {
        window.clearInterval(i);
      }

    });

    this.platform.resume.subscribe(this.OnAppResume.bind(this))

    /**
     * Android Back button
     */
    this.platform.registerBackButtonAction(() => {
      if (self.app.getActiveNavs()[0].canGoBack()) {
        self.app.getActiveNavs()[0].pop();

        self.events.publish("consectus:back");
      } else {
        if (this.settingsProvider.settings.existingCustomer) {
          let active_nav = self.app.getActiveNavs()[0]._views[0].id;
          switch (active_nav) {
            case "ProductFormPage":
              let s = this.settingsProvider.settings;
              let status_state = {
                "state_status": "Existing Active",
                "product_application_id": s.productFormData.product_application_id,
                "account_types_id": s.productFormData.account_types_id
              }
              self.onboardingProvider.updateProductApplicationStatus(status_state).then((result: any) => {
                self.app.getRootNavs()[0].setRoot("HomePage", { selectTab: 1 })
              });
              break;
            case "ThankYouApplyPage":
              self.app.getRootNavs()[0].setRoot("ProductTermsConditionsPage")
              break;
            case "TaxResidencyPage":
              self.app.getRootNavs()[0].setRoot("ViewProductPage")
              break;
            // case "ApplicationContactPage":
            //   self.app.getRootNavs()[0].setRoot("ApplicationAddressPage")
            //   break;
            case "ApplicationAddressPage":
              self.app.getRootNavs()[0].setRoot("ProductFormPage")
              break;
            case "TaxResidencyCountryPage":
              self.app.getRootNavs()[0].setRoot("TaxResidencyPage")
              break;
            case "ProductTermsConditionsPage":
              self.app.getRootNavs()[0].setRoot("TaxResidencyPage")
              break;
            case "BankDetailsPage":
              self.app.getRootNavs()[0].setRoot("ApplicationAddressPage")
              break;
            default:
              self.app.getRootNavs()[0].getActiveChildNav(0).select(0);
              break;
          }
        }
        else {
          self.app.getRootNavs()[0].getActiveChildNav(0).select(0);
        }


        this.menu.close();

      }
      window.isFingerPrintCancel = true;
      const overlayView = this.app._appRoot._overlayPortal._views[0];
      if (overlayView && overlayView.dismiss) {
        overlayView.dismiss();
      }
    });
    /**
    * Get token from the FCM token
    */
    this.initilizationApp();
  }


  OnAppResume(e) {


    const bypassLoginOnResume = [
      "ModalCmp",
      "SavingsGoalPage",
      "BranchesMapPage",
      "ChequeDepositPage",
      "PayContactsPage",
      "WebLoginPage",
      "AgreeTermsConditionsPage",
      "ProductTermsConditionsPage",
      "ForceUpdatePage",
      "ResetPinPage",
      "VerifyPinPage",
      "ProductFormPage",
      "ThankActivePage",
      "ThankYouApplyPage",
      "PayfundsToAccountsPage",
      "ViewProductPage",
      "PayfundsToAccountsPage",
      "OtpPage",
      "ExistingScreenMessagePage",
      "DocumentVerificationResultPage",
      "AccountsDocumentsCheckPage",
      "UploadAddressProofPage",
      "UploadPassportPage",
      "UploadSelfiePage",
      "UploadDrivingPage",
      "UploadPhotoPage"];
    let showLogin = bypassLoginOnResume.indexOf(this.lastView) < 0;
    if (this.lastView === "SplashPage") window.location.reload();

    if (showLogin && !window.openStatement && !this.settingsProvider.settings.existingCustomer && !window.isFingerPrint && window.isFingerPrintCancel) {
      // this.initilizationApp();
      this.getStatusByUUID();
    } else {
      let startTimerPages = [
        "ModalCmp",
        "SavingsGoalPage",
        "BranchesMapPage",
        "ChequeDepositPage",
        "UploadPhotoPage",
        "UploadAddressProofPage",
        "BranchesListPage",
        "ForceUpdatePage",
        "StatementsPage",
        "StatementListPage",
        "NeedHelpFaqPage",
        "SavingsAccountDepositMoneyPage",
        "ViewMessagePage"
      ];
      let startTimer = startTimerPages.indexOf(this.lastView) >= 0;
      if (startTimer) {
        this.inactive.resetCount("LoginFormPage");
        this.nav.setRoot("LoginFormPage")
      }
      window.openStatement = false;
    }
    this.getResumeMethod();
  }

  getTimeOutValue() {
    let timerValue: any = null;
    let currentDate: any = new Date();
    if (this.settingsProvider.settings.timeOut > 0 && this.settingsProvider.settings.timeOut <= this.settingsProvider.settings.timeOutCount * 60) {

      timerValue = (this.settingsProvider.settings.startTimer - currentDate) / 1000;
      return parseInt(timerValue);
    }
  }

  getResumeMethod() {
    if (this.settingsProvider.settings.timeOut > 0 && this.settingsProvider.settings.timeOut <= this.settingsProvider.settings.timeOutCount * 60) {

      this.settingsProvider.settings.timeOut = this.getTimeOutValue();
      if (this.settingsProvider.settings.timeOut <= 0) {
        this.settingsProvider.settings.startTimer = null;
        this.settingsProvider.settings.timeOut = 0;
        this.settingsProvider.setSettings(this.settingsProvider.settings).then((data) => {
          window.clearInterval(window.timer);
        });
      }
    }
  }


  /**
   * Restore and new install for this
   */
  async restoreData() {
    // let self = this;
    // if (this.settingsProvider.isDev) {
    //   var token = await self.fcm.getToken();
    //   
    //   if (token === "" || token === null) {
    //     this.updateDeviceTokenData = {
    //       modelname: self.device.model,
    //       uuid: self.device.uuid,
    //       devicetoken: this.deviceIdToken,
    //       devicetype: self.device.platform
    //     }
    //   } else {
    //     this.updateDeviceTokenData = {
    //       modelname: self.device.model,
    //       uuid: self.device.uuid,
    //       devicetoken: token,
    //       devicetype: self.device.platform
    //     }
    //   }
    //   
    //   //Register device token
    //   self.registerDeviceToken(this.updateDeviceTokenData);
    //   //ensure correct page based on status
    // } else {
    //   //demo use
    //   self.settingsProvider.init(self, self.nav).then(() => {
    //     self.nav.setRoot("LoginFormPage");
    //   })
    // }
  }

  async getToken() {
    let self = this;
    let token = null;
    try {
      setTimeout(function () {
        window.FCMPlugin.getToken(function (data) {
          token = data;
          if (token == "" || token == null) {
            setTimeout(self.getToken.bind(self), 2000);
          } else {

            const updateDeviceTokenData = {
              modelname: self.device.model,
              uuid: self.device.uuid,
              devicetoken: token,
              devicetype: self.device.platform
            }
            if (self.settingsProvider.settings.newAccountId !== "") {
              updateDeviceTokenData['new_accounts_id'] = self.settingsProvider.settings.newAccountId;
            }
            if (self.settingsProvider.settings.customerId !== "" && window.clientDemo) {
              updateDeviceTokenData['customers_id'] = self.settingsProvider.settings.customerId;
            }
            //Register device token
            if (self.settingsProvider.settings.token !== updateDeviceTokenData.devicetoken || window.clientDemo) {
              self.gateway.registerDeviceTokenNew(updateDeviceTokenData).then((result: any) => {
                self.settingsProvider.settings.customer_devices_id = result.customer_devices_id;
                self.settingsProvider.settings.token = updateDeviceTokenData.devicetoken;
                self.settingsProvider.settings.devicetype = self.device.platform;
                self.settingsProvider.setSettings(self.settingsProvider.settings);

              }).catch((error) => {
                self.events.publish("consectus:500.error", error);
              })
            }
            return token;
          }
        });
      }, 3000)
    } catch (e) {


    }
  }
  async initilizationApp() {
    let self = this;
    try {
      try {
        let initSettings = await self.settingsProvider.init(self, self.nav);

        self.getStatusByUUID();
        self.settingsProvider.settings.maxTouchIdAttempt = 0;
        self.settingsProvider.settings.timeOut = 0; // This is only for save attempt = 0
        self.settingsProvider.setSettings(self.settingsProvider.settings).then((data: any) => {

        });
        self.getToken();
      }
      catch (initSettings_err) {

      }
    } catch (error) {

    }
  }

  /**
   * check status of the customer
   */
  getCustomerStatus() {
    window.hideSplash();
    let self = this;
    let isversionvalid = false;
    let thisVersion = Number(window.AppVersion.replace(/\./ig, ''));
    let latestVersion = Number(self.settingsProvider.AppVersion.replace(/\./ig, ''));
    self.settingsProvider.getCustomerStatus(self.settingsProvider.settings.customerId).then((data: any) => {
      //if (window.AppVersion == self.settingsProvider.AppVersion || (self.platform.is("core") || self.platform.is("mobileweb"))) {
      if (latestVersion <= thisVersion || (self.platform.is("core") || self.platform.is("mobileweb"))) {
        isversionvalid = true;

      } else {
        if (self.settingsProvider.settings.forced == 1 && self.settingsProvider.settings.islive == 1) {
          isversionvalid = false;
        }
        else {
          isversionvalid = true;
        }
      }
      if (isversionvalid) {
        if (data.customer_status === "Blocked" || data.customer_status === null) {
          self.settingsProvider.settings.status = data.customer_status;
          self.nav.setRoot("LoginBlockedPage")
        } else {
          self.settingsProvider.settings.status = data.customer_status;
          self.settingsProvider.settings.marketing_post = data.post;
          self.settingsProvider.settings.marketing_email = data.email;
          self.settingsProvider.settings.marketing_telephone = data.telephone;
          self.settingsProvider.settings.marketing_mobilephonesms = data.mobile_phone_sms;
          self.productBadgeCount = data.productcount;
          self.messageBadgeCount = data.msgcount;
          self.newscount = data.newscount;
          self.totalcount = data.totalcount;
          self.settingsProvider.settings.totalcount = data.totalcount;
          self.settingsProvider.settings.productBadgeCount = data.productcount;
          self.settingsProvider.settings.newsBadgeCount = data.newscount;
          self.settingsProvider.settings.messageBadgeCount = data.msgcount;
          self.badge.set(self.settingsProvider.settings.totalcount);

          self.events.publish('consectus:badge.update', data);
          self.settingsProvider.settings.maxTouchIdAttempt = 0; // This is only for save attempt = 0
          self.settingsProvider.setSettings(self.settingsProvider.settings).then((data: any) => {

          });
          self.onResume(false);
        }
      }
      else {
        self.commonUpdateBox(true);
      }
    });
  }

  /**
   * Force update box
   * @param cusotmerUpdateFlag 
   */
  commonUpdateBox(cusotmerUpdateFlag) {

    window.hideSplash();
    this.nav.setRoot("ForceUpdatePage")
  }

  /**
   * Get status of the customer from hub
   */
  getStatus() {
    window.hideSplash();
    let self = this;
    //if (self.settingsProvider.settings.customerId && self.settingsProvider.settings.status == "Existing Active") {
    if (self.settingsProvider.settings.customerId && (self.settingsProvider.settings.status == "Active" || self.settingsProvider.settings.status == "Blocked" || self.settingsProvider.settings.status == "Existing Active" || self.settingsProvider.settings.status == "Existing Customer Mailer" || self.settingsProvider.settings.status == "Existing Customer Document Verification" || self.settingsProvider.settings.status == "Existing Customer Address Verification" || self.settingsProvider.settings.status == "Existing Customer Verification Status" || self.settingsProvider.settings.status == "Existing Customer Credit Check Failed" || self.settingsProvider.settings.status == "Existing Customer Application pending" || self.settingsProvider.settings.status == "Existing Customer Application pending")) {
      self.getCustomerStatus();
    } else {
      let isversionvalid = false;
      self.onboardingProvider.getStatus().then((result: any) => {
        if (result.version == self.settingsProvider.AppVersion) {
          isversionvalid = true;
        } else {
          if (self.settingsProvider.settings.forced == 1 && self.settingsProvider.settings.islive == 1) {
            isversionvalid = false;
          }
          else {
            isversionvalid = true;
          }
        }
        if (isversionvalid) {
          if (result.status) {
            let s = self.settingsProvider.settings;
            if (result.state_status == "New Customer Application Approved") {
              s.productFormData = null;
              if (s.account_number !== null) {
                self.nav.setRoot("PayfundsToAccountsPage");
              }
              else {
                s.customerId = result.results.customers_id;
                s.firstname = result.results.firstname;
                s.lastname = result.results.lastname;
                s.account_number = result.results.account_number;
              }
            }
            s.status = result.state_status;
            self.settingsProvider.setSettings(s).then((data: any) => {

            });

            self.onResume(false);
          } else {
            self.nav.setRoot("HintPage");
          }
        }
        else {
          self.commonUpdateBox(false);
        }

      });

    }
  }


  /**
   * Get status of the customer from UUOD
   */
  getStatusByUUID() {
    try {
      window.hideSplash();
      let self = this;
      let isversionvalid = null;
      if (this.platform.is('android') || this.platform.is('ios')) {
        self.sql_db = window.sqlitePlugin.openDatabase({ name: 'consectus.db', location: 'default' });
        self.sql_db.transaction(function (create_transaction) {
          create_transaction.executeSql('CREATE TABLE IF NOT EXISTS tbl_new_accounts (uuid text)', [],
            function (tx1, result) {
              self.sql_db.transaction(function (transaction) {
                transaction.executeSql("SELECT uuid FROM tbl_new_accounts LIMIT 1", [], function (tx, select_result) {

                  let db_uuid = select_result.rows.item(0) ? select_result.rows.item(0).uuid : "";
                  self.onboardingProvider.getStatus_by_UUID(
                    {
                      "uuid": db_uuid,
                      "devicetype": self.device.platform,
                      "new_accounts_id": self.settingsProvider.settings.newAccountId
                    }
                  )
                    .then((result: any) => {
                      if (result.status) {
                        if (!db_uuid) {

                          self.sql_db.transaction(function (truncate_transaction) {
                            truncate_transaction.executeSql("DELETE FROM tbl_new_accounts", [], function (tx, insert_result) {

                              self.sql_db.transaction(function (insert_transaction) {
                                insert_transaction.executeSql("INSERT INTO tbl_new_accounts (uuid) VALUES (?)", [result.data.uuid], function (tx, insert_result) {

                                },
                                  function (tx, insert_error) {

                                  })
                              })
                            },
                              function (tx, truncate_error) {

                              })
                          })
                        }
                        if (result.version == window.AppVersion) {
                          isversionvalid = true;
                        } else {
                          if (self.settingsProvider.settings.forced == 1 && self.settingsProvider.settings.islive == 1) {
                            isversionvalid = false;
                          }
                          else {
                            isversionvalid = true;
                          }
                        }
                        if (isversionvalid) {
                          if (result.data.customers_id && result.data.customer_status) {
                            if (result.data.customer_status === "Blocked" || result.data.customer_status === null) {
                              self.settingsProvider.settings.status = result.data.customer_status;
                              self.nav.setRoot("LoginBlockedPage")
                            }
                            else {
                              if (result.data.ecao_status) {
                                self.settingsProvider.settings.status = result.data.state_status;
                              }
                              else {
                                self.settingsProvider.settings.status = result.data.state_status;
                              }

                              self.settingsProvider.settings.marketing_post = result.data.post;
                              self.settingsProvider.settings.marketing_email = result.data.email;
                              self.settingsProvider.settings.marketing_telephone = result.data.telephone;
                              self.settingsProvider.settings.marketing_mobilephonesms = result.data.mobile_phone_sms;
                              self.productBadgeCount = result.data.productcount;
                              self.messageBadgeCount = result.data.msgcount;
                              self.newscount = result.data.newscount;
                              self.totalcount = result.data.totalcount;
                              self.settingsProvider.settings.totalcount = result.data.totalcount;
                              self.settingsProvider.settings.productBadgeCount = result.data.productcount;
                              self.settingsProvider.settings.newsBadgeCount = result.data.newscount;
                              self.settingsProvider.settings.messageBadgeCount = result.data.msgcount;
                              self.settingsProvider.settings.customerId = result.data.customers_id;
                              self.badge.set(self.settingsProvider.settings.totalcount);

                              self.events.publish('consectus:badge.update', result.data);
                              self.settingsProvider.settings.maxTouchIdAttempt = 0; // This is only for save attempt = 0
                              self.settingsProvider.setSettings(self.settingsProvider.settings).then((data: any) => {

                              });
                            }
                          }
                          else {
                            let s = self.settingsProvider.settings;
                            let formdata = self.settingsProvider.settings.productFormData;
                            if (result.data.state_status == "New Customer Application Approved") {

                              s.productFormData = null;
                              if (s.account_number !== null) {
                                self.nav.setRoot("PayfundsToAccountsPage");
                              }
                              else {
                                s.customerId = result.results.customers_id;
                                s.firstname = result.results.firstname;
                                s.lastname = result.results.lastname;
                                s.account_number = result.results.account_number;
                              }
                            }

                            try {
                              s.status = result.data.state_status;
                              s.newAccountId = result.data.new_accounts_id;

                              formdata.new_accounts_id = formdata.new_accounts_id == "" || formdata.new_accounts_id == undefined || formdata.new_accounts_id == null ? result.data.new_accounts_id : formdata.new_accounts_id;
                              formdata.account_types_id = formdata.account_types_id == "" || formdata.account_types_id == undefined || formdata.account_types_id == null ? result.data.account_types_id : formdata.account_types_id;

                              formdata.title = formdata.title == "" || formdata.title == undefined || formdata.title == null ? result.data.title : formdata.title;
                              formdata.firstname = formdata.firstname == "" || formdata.firstname == undefined || formdata.firstname == null ? result.data.firstname : formdata.firstname;
                              formdata.middlename = formdata.middlename == "" || formdata.middlename == undefined || formdata.middlename == null ? result.data.middlename : formdata.middlename;
                              formdata.lastname = formdata.lastname == "" || formdata.lastname == undefined || formdata.lastname == null ? result.data.lastname : formdata.lastname;
                              formdata.nationalinsuranceno = formdata.nationalinsuranceno == "" || formdata.nationalinsuranceno == undefined || formdata.nationalinsuranceno == null ? result.data.nationalinsuranceno : formdata.nationalinsuranceno;
                              formdata.emailid = formdata.emailid == "" || formdata.emailid == undefined || formdata.emailid == null ? result.data.emailid : formdata.emailid;

                              if (formdata.address) {
                                formdata.address[0].add3 = formdata.address[0].add3 == "" || formdata.address[0].add3 == undefined || formdata.address[0].add3 == null ? result.data.add3 : formdata.address[0].add3;
                                formdata.address[0].city = formdata.address[0].city == "" || formdata.address[0].city == undefined || formdata.address[0].city == null ? result.data.city : formdata.address[0].city;
                                formdata.address[0].houseno = formdata.address[0].houseno == "" || formdata.address[0].houseno == undefined || formdata.address[0].houseno == null ? result.data.add1 : formdata.address[0].houseno;
                                //formdata.address[0].islivetwelemonth = formdata.address[0].islivetwelemonth == "" || formdata.address[0].islivetwelemonth == undefined || formdata.address[0].islivetwelemonth == null ? result.data.islivetwelemonth : formdata.address[0].islivetwelemonth;
                                formdata.address[0].moveindate = formdata.address[0].moveindate == "" || formdata.address[0].moveindate == undefined || formdata.address[0].moveindate == null ? result.data.moveindate : formdata.address[0].moveindate;
                                formdata.address[0].moveoutdate = formdata.address[0].moveoutdate == "" || formdata.address[0].moveoutdate == undefined || formdata.address[0].moveoutdate == null ? result.data.moveoutdate : formdata.address[0].moveoutdate;
                                formdata.address[0].postalcode = formdata.address[0].postalcode == "" || formdata.address[0].postalcode == undefined || formdata.address[0].postalcode == null ? result.data.postalcode : formdata.address[0].postalcode;
                                formdata.address[0].street = formdata.address[0].street == "" || formdata.address[0].street == undefined || formdata.address[0].street == null ? result.data.street : formdata.address[0].street;
                              }


                              formdata.accountsortcode = formdata.accountsortcode == "" || formdata.accountsortcode == undefined || formdata.accountsortcode == null ? result.data.accountsortcode : formdata.accountsortcode;
                              formdata.nominatedbankno = formdata.nominatedbankno == "" || formdata.nominatedbankno == undefined || formdata.nominatedbankno == null ? result.data.nominatedbankno : formdata.nominatedbankno;
                              formdata.accountholdername = formdata.accountholdername == "" || formdata.accountholdername == undefined || formdata.accountholdername == null ? result.data.accountholdername : formdata.accountholdername;

                              //formdata.taxresident = formdata.taxresident == "" || formdata.taxresident == undefined || formdata.taxresident == null ? result.data.taxresident : formdata.taxresident;
                              //formdata.products_id = formdata.products_id == "" || formdata.products_id == undefined || formdata.products_id == null ? result.data.products_id : formdata.products_id;
                              //formdata.accountcode = formdata.accountcode == "" || formdata.accountcode == undefined || formdata.accountcode == null ? result.data.accountcode : formdata.accountcode;
                              //s.accountcode = s.accountcode == "" || s.accountcode == undefined || s.accountcode == null ? result.data.accountcode : s.accountcode;
                              //formdata.accountname = formdata.accountname == "" || formdata.accountname == undefined || formdata.accountname == null ? result.data.accountname : formdata.accountname;
                              //formdata.dob = formdata.dob == "" || formdata.dob == undefined || formdata.dob == null ? result.data.dob : formdata.dob;
                              //formdata.istermsandcondition = formdata.istermsandcondition == "" || formdata.istermsandcondition == undefined || formdata.istermsandcondition == null ? result.data.istermsandcondition : formdata.istermsandcondition;
                              //formdata.country = formdata.country == "" || formdata.country == undefined || formdata.country == null ? result.data.country : formdata.country;
                              //formdata.customer_devices_id = formdata.customer_devices_id == "" || formdata.customer_devices_id == undefined || formdata.customer_devices_id == null ? result.data.customer_devices_id : formdata.customer_devices_id;


                              //s.userMobileNo = s.userMobileNo == "" || s.userMobileNo == undefined || s.userMobileNo == null ? result.data.mobileno : s.userMobileNo;


                              self.settingsProvider.setSettings(s).then((data: any) => {

                              });
                            } catch (ex) {

                            }
                          }

                          self.onResume(false);
                        }
                        else {
                          self.commonUpdateBox(false);
                        }
                      }
                      else {

                      }
                    }).catch((err) => {

                    })
                },
                  function (tx, select_error) {

                  });
              })

            },
            function (tx, create_error) {

            })
        })
      }
    }
    catch (err) {
    }
  }

  dummyscript() {
    let self = this;
    if (this.platform.is('android') || this.platform.is('ios')) {
      self.sql_db = window.sqlitePlugin.openDatabase({ name: 'consectus.db', location: 'default' });
      self.sql_db.transaction(function (create_transaction) {
        create_transaction.executeSql('DROP TABLE IF EXISTS tbl_new_accounts', [],
          function (tx1, result) {

          })
      })
    }
  }

  /* Called this function after app in background and check the status 
  of the customer */
  onResume(flag) {
    let self = this;
    if (window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches) {
      // dark mode

      window.addDarkMode();
    }
    else {

      window.addLightMode();
    }

    self.settingsProvider.getAllStatus();

    const overlayView = this.app._appRoot._overlayPortal._views[0];
    if (overlayView && overlayView.dismiss) {
      overlayView.dismiss();
    }
  }


  /**
   * show login page on resume of active status
   */
  resumeActiveStatus() {
    let self = this;
    if (self.lastView) {
      var newArr = ["LoginFormPage", "ModalCmp", "SavingsGoalPage", "BranchesMapPage", "ChequeDepositPage", "PayContactsPage"];

      if (newArr.indexOf(self.lastView) < 0) {
        let self = this;
        // this.modal = this.modalCtrl.create("LoginFormPage", { resumed: true, customerStatus:this.customerStatus });
        // this.modal.onDidDismiss((data) => {
        //   self.modal = null;
        // })
        // this.modal.present();
        self.nav.setRoot("LoginFormPage", { customerStatus: this.customerStatus });
      }

    } else {
      self.nav.setRoot("LoginFormPage", { customerStatus: this.customerStatus });
    }
  }

  //tabs index with splitpane menu
  redirectPage(PageIndex) {

    switch (PageIndex) {
      case 0:
        this.app.getRootNav().getActiveChildNav().select(0);
        this.menu.close();
        break;
      case 1:
        // froduct
        // this.nav.push("ProductsPage");
        this.app.getRootNav().getActiveChildNav().select(1);
        this.menu.close();
        break;
      case 2:
        // this.nav.push("MessagesPage");
        //messages
        this.app.getRootNav().getActiveChildNav().select(2);
        this.menu.close();
        break;
      case 3:
        // this.nav.push("BranchesListPage");
        this.menu.close();
        this.app.getRootNav().getActiveChildNav().select(3);
        break;
      case 8:
        this.app.getRootNav().getActiveChildNav().select(8);
        this.menu.close();
        break;
      case 9:
        this.app.getRootNav().getActiveChildNav().select(9);
        this.menu.close();
        break;
      case 16:
        //open new account
        // this.nav.push("CreateNewAccountPage");
        this.app.getRootNav().getActiveChildNav().select(16);
        this.menu.close();
        break;
      case 'analysis':
        //open new account
        // this.nav.push("CreateNewAccountPage");
        this.app.getRootNav().getActiveChildNav().select(15);
        this.menu.close();
        break;
      case 17:
        this.app.getRootNav().getActiveChildNav().select(17);
        this.menu.close();
        break;
      case 18:
        // faq
        // this.nav.push("FaqCategoryPage");
        this.app.getRootNav().getActiveChildNav().select(18);
        this.menu.close();
        break;
      case 19:
        //important information
        // this.nav.push("InfoPage");
        this.app.getRootNav().getActiveChildNav().select(19);
        this.menu.close();
        break;
      case 20:
        //important information
        // this.nav.push("InfoPage");
        this.app.getRootNav().getActiveChildNav().select(20);
        this.menu.close();
        break;
      case 21:
        //transfer list
        // this.nav.push("SavingsAccountDepositMoneyPage");
        this.app.getRootNav().getActiveChildNav().select(21);
        this.menu.close();
        break;
      case 'Statement':
        this.app.getRootNav().getActiveChildNav().select(23);
        this.menu.close();
        break;
      case 24:
        this.app.getRootNav().getActiveChildNav().select(24);
        this.menu.close();
        break;
      case 'settings':
        //settings
        // this.nav.push("SettingsPage");
        this.app.getRootNav().getActiveChildNav().select(4);
        this.menu.close();
        break;
      case 'ag':
        this.menu.close();
        this.app.getRootNav().getActiveChildNav().select(5);
        break;
      case 'sa':
        this.menu.close();
        this.app.getRootNav().getActiveChildNav().select(6);
        break;
      case 'ma':
        this.menu.close();
        this.app.getRootNav().getActiveChildNav().select(7);
        break;
      case 'notifications':
        this.menu.close();
        this.app.getRootNav().getActiveChildNav().select(10);
        break;
      case 'terms':
        this.menu.close();
        this.app.getRootNav().getActiveChildNav().select(11);
        break;
      case 'contact':
        //contact
        // this.nav.push("ContactUsPage");
        this.menu.close();
        this.app.getRootNav().getActiveChildNav().select(12);
        break;

      case 'close':
        this.menu.close();
        break;
      case 'calculator':
        this.menu.close();
        this.app.getRootNav().getActiveChildNav().select(13);
        break;
      case 'statementListing':
        this.menu.close();
        this.app.getRootNav().getActiveChildNav().select(24);
        break;
      case 'deposit':
        this.menu.close();
        this.app.getRootNav().getActiveChildNav().select(14);
        break;
      case 'logout':
        this.menu.close();

        let ss = this.settingsProvider.settings;
        ss.manually_logout = true;
        ss.timer_logout = false;
        this.settingsProvider.setSettings(ss).then(() => {
          this.events.publish("consectus:loginform");
        });
        break;
      case 'reset':
        this.menu.close();
        let s = this.settingsProvider.settings;
        let alert = this.alertCtrl.create({
          title: this.settingsProvider.getLabel("Step One"),
          message: this.settingsProvider.getLabel("Please not that all the data on this device will be cleared.\nYou will have to re-register to use the App."),
          buttons: [
            {
              text: this.settingsProvider.getLabel('OK'),
              role: 'ok',
              handler: () => {
                this.settingsProvider.clearSettings(this, this.nav).then(async (res) => {
                  this.getToken();
                });
              }
            },
            {
              text: this.settingsProvider.getLabel('NO'),
              role: 'cancel',
              handler: () => {

              }
            }
          ]
        });
        alert.present();
        break;
      default:
        break;
    }
  }

  closeMenu() {
    this.menu.close();
  }

  /**
   * Registerdevice token data
   * @param updateDeviceTokenData 
   */
  registerDeviceToken(updateDeviceTokenData) {
    let self = this;
    return new Promise((resolve, reject) => {
      self.gateway.registerDeviceToken(updateDeviceTokenData).then((result: any) => {

        self.settingsProvider.settings.status = result.state_status;
        self.settingsProvider.settings.token = updateDeviceTokenData.devicetoken;
        self.settingsProvider.settings.newAccountId = result.new_accounts_id;
        self.settingsProvider.settings.customer_devices_id = result.customer_devices_id;
        self.settingsProvider.settings.customerId = window.clientDemo ? window.clientCustomerId : "";
        //Used for the contct us us button for ios
        self.settingsProvider.settings.isSendMailerMail = false;
        self.settingsProvider.settings.isSendPasscodeMail = false;
        self.settingsProvider.settings.isSendRegisterMail = false;
        self.settingsProvider.settings.isSendMemberIdMail = false;
        self.settingsProvider.settings.isSendExisitingMail = false;
        self.settingsProvider.settings.isSendLoginMail = false
        self.settingsProvider.settings.startTimer = null;
        self.settingsProvider.settings.maxTouchIdAttempt = 0;
        self.settingsProvider.settings.attempts = 0;
        self.settingsProvider.settings.isNewExistingNumber = false;
        self.settingsProvider.settings.touchEnabled = true;
        self.settingsProvider.settings.isSetPin = true;
        self.settingsProvider.settings.isLoginBlocked = false;
        self.settingsProvider.settings.labelsData = null;
        self.settingsProvider.settings.bankSettingData = null;
        self.settingsProvider.settings.productFormData = null;
        //ios
        self.settingsProvider.settings.newUser = true; // This is only for ios(securestorage not deleted from app)
        self.settingsProvider.setSettings(self.settingsProvider.settings).then((data: any) => {

        });
        // self.nav.setRoot("LoginFormPage");
        // self.nav.setRoot("HintPage");
        resolve(true);
      }).catch((error) => {
        reject(error);
      });

    })
  }

  initializeOnline(isDevelopment) {

    let self = this;


    this.events.subscribe("consectus:redirectlogin", () => {
      self.nav.setRoot("LoginPage");
    });

    this.events.subscribe("consectus:loginform", () => {

      // self.nav.setRoot("LoginFormPage")
      this.settingsProvider.showLoading();
      // this.menu_option = false;
      location.href = "#/web-login";
      setTimeout(() => {
        this.settingsProvider.hideLoading();
        location.reload();
      }, 1500);
    });

    this.events.subscribe("consectus:login", () => {
      self.nav.setRoot("HomePage")
    });

    self.settingsProvider.init(self, self.nav).then(() => {
      self.isWebOnboarding = true;
      // self.settingsProvider.settings.customerId = 1;
      // self.settingsProvider.settings.newAccountId = 2006;
      // self.settingsProvider.settings.status_state = "Active";
      // self.settingsProvider.settings.status = "Active";
      // console.log(localStorage.getItem("xid"))
      if (localStorage.getItem("xid") != 'null') {
        self.nav.setRoot("OnlineMigrationPage");
      }
      else {
        self.nav.setRoot("WebLoginPage");
      }
      window.hideSplash()
      // self.getStatus();
    }).catch((error) => {
      // console.log(error)
    });
  }
}


// WEBPACK FOOTER //
// ./src/app/app.component.ts